<template>
  <div>
    <!--Header-->
    <div class="header homepage pt-5 pb-7 d-flex align-items-center">
      <b-container class="full-height">
        <div class="header-body">
          <b-row align-v="center" >
            <b-col cols="12">
              <div class="pr-5">
                <h1 class="display-2 text-im2u font-weight-bold mb-0">Welcome to Invinity LMS V2</h1>
                <h2 class="display-5 text-im2u font-weight-light">Level up your competitiveness by maintaining top performance at managing mortgage loan products for individuals and business customers with end-to-end loan origination system.</h2>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .text-im2u{
    color:#252938
  }
  .full-height{
		height: calc(100vh - 18.5rem);
  }
</style>
<script>
  export default {
    name: 'home-page'
  };
</script>
